const RECENT_SEARCHES = 'recent_searches';
const COMPANY_CURRENCY = 'company_currency';

const LS_CACHE: Record<string, unknown> = {};

interface RecentSearch {
  mainText: string;
  secondaryText: string;
}

function get<T>(key: string, missing: T): T {
  try {
    const rawValue = localStorage.getItem(key);
    if (rawValue !== null) {
      const parsedValue = JSON.parse(rawValue) as T;
      LS_CACHE[key] = parsedValue;
      return parsedValue;
    }
  } catch (e) {
    console.error('Local storage not supported.', e);
    return (LS_CACHE[key] ?? missing) as T;
  }
  return missing;
}

function set(key: string, data: unknown): void {
  LS_CACHE[key] = data;
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (e) {
    console.error('Local storage not supported.', e);
  }
}

function getCompanyCurrency() {
  return get(COMPANY_CURRENCY, '$');
}

function setCompanyCurrency(currency: string) {
  set(COMPANY_CURRENCY, currency);
}

function getRecentSearches(): RecentSearch[] {
  return get(RECENT_SEARCHES, []);
}

function setRecentSearches(search: RecentSearch) {
  const currentSearches = getRecentSearches() || [];
  currentSearches.push(search);
  set(RECENT_SEARCHES, currentSearches);
}

const LocalStorage = {
  getCompanyCurrency,
  setCompanyCurrency,
  getRecentSearches,
  setRecentSearches,
};

export default LocalStorage;
